import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import AuthView from '@/layouts/Auth.vue';
import DashView from '@/layouts/Dash.vue';
import OnboardingView from '@/layouts/Onboarding.vue';
import UserOnboardingView from '@/layouts/UserOnboarding.vue';
import PaymentView from '@/layouts/Payment.vue';

import OrgDetail from '@/views/onboarding/OrgDetail.vue';
import VerifyCode from '@/views/onboarding/VerifyCode.vue';
import OrgType from '@/views/onboarding/OrgType.vue';
import AgreeRules from '@/views/onboarding/AgreeRules.vue';
import CausesBullhorns from '@/views/onboarding/Bullhorns.vue';
import Channels from '@/views/onboarding/Channels.vue';
import OrgValues from '@/views/onboarding/OrgValues.vue';
import WhyJoiningSpotlight from '@/views/onboarding/WhyJoiningSpotlight.vue';
import Onboarded from '@/views/onboarding/Onboarded.vue';

import UserDetail from '@/views/user-onboarding/UserDetail.vue';
import VerifyUserCode from '@/views/user-onboarding/VerifyCode.vue';
import AgreeUserRules from '@/views/user-onboarding/AgreeRules.vue';
import UserCauses from '@/views/user-onboarding/Bullhorns.vue';
import UserChannels from '@/views/user-onboarding/Channels.vue';
import UserValues from '@/views/user-onboarding/Values.vue';
import UserWhyJoiningSpotlight from '@/views/user-onboarding/WhyJoiningSpotlight.vue';
import UserOnboarded from '@/views/user-onboarding/Onboarded.vue';

import Authenticator from '@/views/Authenticator.vue';
import ForgotPassword from '@/views/forgot-password/ForgotPassword.vue';
import VerifyResetCode from '@/views/forgot-password/VerifyResetCode.vue';
import UpdatePassword from '@/views/forgot-password/UpdatePassword.vue';
import Dashboard from '../views/Dashboard.vue';

import ManageUsersAndOrganizations from '../views/manage-users-and-organizations/Index.vue';
import ManageUsers from '../views/manage-users-and-organizations/ManageUsers.vue';
import ManageOrganizations from '../views/manage-users-and-organizations/ManageOrganizations.vue';
import ManageUsersEdit from '../views/manage-users-and-organizations/UsersEdit.vue';
import ManageOrganizationsEdit from '../views/manage-users-and-organizations/org-edit/Index.vue';
import ConfirmOrgOnboard from '../views/manage-users-and-organizations/org-edit/ConfirmOrgOnboard.vue';
import OrgSticker from '../views/manage-users-and-organizations/org-edit/OrgSticker.vue';
import ManageOrgStickers from '../views/manage-users-and-organizations/org-edit/OrgStickers.vue';
import OrgPageAddSticker from '../views/manage-users-and-organizations/org-edit/OrgPageAddSticker.vue';
// sticker redesigned
import AddSticker from '../views/manage-content/media/add-sticker/AddSticker.vue';

import Invites from '../views/manage-users-and-organizations/Invites.vue';
import InviteDetail from '../views/manage-users-and-organizations/InviteDetail.vue';
import Consents from '../views/manage-users-and-organizations/Consents.vue';

import ManageBenevityClaim from '../views/manage-users-and-organizations/benevity-claim/index.vue';

import ManageContent from '../views/manage-content/Index.vue';

import ManageContentSpots from '../views/manage-content/spots/Index.vue';
import ManageContentSpotDetail from '../views/manage-content/spots/Detail.vue';

import ManageContentEvents from '../views/manage-content/events/Index.vue';
import ManageContentEventDetail from '../views/manage-content/events/Detail.vue';

import ActivityLogs from '../views/activity/ActivityLogs.vue';

// Directory
import ManageContentDirectory from '../views/manage-content/directory/Index.vue';

import ManageContentDirectoryBullhorns from '../views/manage-content/directory/bullhorns/Index.vue';
import ManageContentDirectoryBullhornDetail from '../views/manage-content/directory/bullhorns/Detail.vue';

import ManageContentDirectoryChannels from '../views/manage-content/directory/channels/Index.vue';
import ManageContentDirectoryChannelDetail from '../views/manage-content/directory/channels/Detail.vue';

import ManageContentDirectoryValues from '../views/manage-content/directory/values/Index.vue';
import ManageContentDirectoryValueDetail from '../views/manage-content/directory/values/Detail.vue';

import ManageContentDirectoryInterests from '../views/manage-content/directory/interests/Index.vue';
import ManageContentDirectoryInterestDetail from '../views/manage-content/directory/interests/Detail.vue';

import ManageContentDirectoryDictionary from '../views/manage-content/directory/dictionary/Index.vue';
import ManageContentDirectoryDictionaryDetail from '../views/manage-content/directory/dictionary/Detail.vue';

import ManageContentDirectorySegments from '../views/manage-content/directory/segments/Index.vue';
import ManageContentDirectorySegmentDetail from '../views/manage-content/directory/segments/Detail.vue';

import OrgPaymentLogs from '../views/manage-content/payment-log/OrgIndex.vue';
import PaymentLogDetails from '../views/manage-content/payment-log/Details.vue';

// Resources
import ManageResources from '../views/manage-resources/Index.vue';
import Todos from '../views/manage-resources/todo/Index.vue';
import Todo from '../views/manage-resources/todo/Todo.vue';

import Workflows from '../views/manage-resources/workflow/Index.vue';
import Workflow from '../views/manage-resources/workflow/Workflow.vue';

// Media
import ManageContentMedia from '../views/manage-content/media/Index.vue';

import ManageContentMediaStickers from '../views/manage-content/media/stickers/Index.vue';
import ManageContentMediaStickerDetail from '../views/manage-content/media/stickers/Detail.vue';
import PageAddSticker from '../views/manage-content/media/stickers/PageAddSticker.vue';

import ManageContentMediaGlows from '../views/manage-content/media/glows/Index.vue';
import ManageContentMediaCreateGlow from '../views/manage-content/media/glows/CreateGlow.vue';

import ManageContentMediaLibrary from '../views/manage-content/media/library/Index.vue';
import ManageContentMediaLibraryItemDetail from '../views/manage-content/media/library/Detail.vue';

import ManageContentMediaStaticPages from '../views/manage-content/media/static-pages/Index.vue';
import ManageContentMediaStaticPageDetail from '../views/manage-content/media/static-pages/Detail.vue';
import ManageContentMediaAddStaticPage from '../views/manage-content/media/static-pages/AddStaticPage.vue';

import ManageContentMediaQuestions from '../views/manage-content/media/questions/Index.vue';
import ManageContentMediaQuestionDetail from '../views/manage-content/media/questions/Detail.vue';
import ManageContentAddBullhorn from '../views/manage-content/add-item/AddBullhorn.vue';
import ManageContentAddChannel from '../views/manage-content/add-item/AddChannel.vue';
import ManageContentAddValue from '../views/manage-content/add-item/AddValue.vue';
import ManageContentAddInterest from '../views/manage-content/add-item/AddInterest.vue';

import Marketing from '../views/marketing/Index.vue';
import Civics from '../views/civics/Index.vue';

import Settings from '../views/Settings.vue';
import FileUpload from '../views/FileUpload.vue';

import authGuard from './authGuard.js';

import PaymentStatic from '../views/payments/PaymentStatic.vue';
import FinalizePayment from '../views/payments/FinalizePayment.vue';
import PaymentIntent from '../views/payments/PaymentIntent.vue';
import StickerPurchase from '../views/payments/StickerPurchase.vue';
import InitiateWalletPaymentIntent from '../views/payments/InitiateWalletPaymentIntent.vue';

import WebAppDashboard from '../views/web-app/dashboard/WebAppDashboard.vue';
import WebAppSticker from '../views/web-app/sticker/StickerDetails.vue';
import WebAppStickerPublic from '../views/web-app/sticker/StickerDetailsPublic.vue';
import StickerCheckout from '../views/web-app/sticker/StickerCheckout.vue';
import TicketCheckout from '../views/web-app/sticker/TicketCheckout.vue';
import TicketSuccess from '../views/web-app/sticker/TicketSuccess.vue';
import WebAppSignIn from '../views/web-app/auth/SignIn.vue';
import WebAppSignUp from '../views/web-app/auth/SignUp.vue';
import WebCompleteProfile from '../views/web-app/auth/CompleteProfile.vue';
import WebAppPurchasedStickers from '../views/web-app/sticker/PurchasedStickers.vue';
import MyTicketOrders from '../views/web-app/sticker/MyTicketOrders.vue';
import MyFavorites from '../views/web-app/sticker/MyFavorites.vue';
import TicketsViewer from '../views/web-app/sticker/TicketsViewer.vue';
import TicketDetailPage from '../views/web-app/sticker/TicketDetailPage.vue';
import HostCheckIn from '../views/web-app/sticker/HostCheckIn.vue';
import HostAnnouncements from '../views/web-app/sticker/HostAnnouncements.vue';
import HostQuestions from '../views/web-app/sticker/HostQuestions.vue';
import HostTicketInsights from '../views/web-app/sticker/HostTicketInsights.vue';
import StickerAnalytics from '../views/web-app/sticker/StickerAnalytics.vue';
import WebAppProfile from '../views/web-app/profile/user/Profile.vue';
import OrganizationProfile from '../views/web-app/profile/organization/OrganizationProfile.vue';
import ClaimRequestDetailsVue from '@/views/manage-users-and-organizations/benevity-claim/ClaimRequestDetails.vue';
import StaticPage from '../views/web-app/static-pages/StaticPage.vue';
import CollectionDetail from '../views/web-app/CollectionDetail.vue';
import Search from '../views/web-app/search/Search.vue';
import CreateGivingWallet from '../views/web-app/wallet/CreateGivingWallet.vue';
import MailingAddress from '../views/web-app/wallet/MailingAddress.vue';
import WalletDashboard from '../views/web-app/wallet/WalletDashboard.vue';
import AddFunds from '../views/web-app/wallet/AddFunds.vue';

const routes: Array<RouteRecordRaw> = [
  // Route Examples
  // { path: '/', name: 'Home', component: Home, },
  {
    path: '/auth',
    name: 'AuthView',
    component: AuthView,
    children: [
      {
        path: '/sign-in',
        alias: '/auth',
        name: 'Authentpicator',
        component: Authenticator,
      },
      {
        path: '/auth/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPassword,
      },
      {
        path: '/auth/forgot-password/:userId/verify-resetcode',
        name: 'VerifyResetCode',
        component: VerifyResetCode,
      },
      {
        path: '/auth/forgot-password/update-password/:token',
        name: 'UpdatePassword',
        component: UpdatePassword,
      },
    ],
  }, {
    path: '/payment',
    name: 'PaymentView',
    component: PaymentView,
    children: [
      {
        path: ':transactionCode/make', name: 'FinalizePayment', component: FinalizePayment,
      },
      {
        path: '/payment-static', name: 'PaymentStatic', component: PaymentStatic,
      },
      {
        path: 'intent/user/:userId', name: 'PaymentIntent', component: PaymentIntent,
      },
      {
        path: 'intent/user/:userId/org/:orgId', name: 'OrgPaymentIntent', component: PaymentIntent,
      },
      {
        path: 'intent/user/:userId/followingGroup/:followingGroupId', name: 'FollowingGroupPaymentIntent', component: PaymentIntent,
      },
      {
        path: 'intent/user/:userId/org/:orgId/followingGroup/:followingGroupId', name: 'OrgFollowingGroupPaymentIntent', component: PaymentIntent,
      },
      {
        path: 'intent/user/:userId/sticker/:stickerId/cause/:causeId', name: 'StickerPurchase', component: StickerPurchase,
      },
      {
        path: 'intent/sticker/:stickerId/cause/:causeId/variants/:variantIds/quantities/:quantities', name: 'StickerVariant', component: StickerPurchase,
      },
      {
        path: '/payment/intent/sticker/:stickerId/cause/:causeId/variants/:variantIds/quantities/:quantities(.*)', component: StickerPurchase,
      },
      {
        path: 'intent/user/:userId/org/:orgId/sticker/:stickerId/cause/:causeId/variants/:variantIds/quantities/:quantities',
        name: 'StickerVariant',
        component: StickerPurchase,
      },
      {
        path: 'intent/user/:userId/sticker/:stickerId/cause/:causeId/variants/:variantIds/quantities/:quantities', name: 'StickerVariantPurchase', component: StickerPurchase,
      },
      {
        path: 'intent/sticker/:stickerId/cause/:causeId', name: 'StickerPurchasePublic', component: StickerPurchase,
      },
      {
        path: 'intent/user/:userId/org/:orgId/sticker/:stickerId/cause/:causeId', name: 'OrgStickerPurchase', component: StickerPurchase,
      },
      {
        path: 'intent/initiatewallet/user/:userId/org/:orgId/walletPricing/:walletPricingId', name: 'InitiateWalletPaymentIntent', component: InitiateWalletPaymentIntent,
      },
      {
        path: 'intent/cart/:cartId', name: 'CartPaymentIntent', component: TicketCheckout,
      },
    ],
  }, {
    path: '/onboarding',
    name: 'OnboardingView',
    component: OnboardingView,
    children: [
      { path: ':orgId/org-detail', name: 'OrgDetail', component: OrgDetail },
      { path: ':orgId/verify-code', name: 'VerifyCode', component: VerifyCode },
      { path: ':orgId/org-type', name: 'OrgType', component: OrgType },
      { path: ':orgId/agree-rules', name: 'AgreeRules', component: AgreeRules },
      { path: ':orgId/causes', name: 'CausesBullhorns', component: CausesBullhorns },
      { path: ':orgId/channels', name: 'Channels', component: Channels },
      { path: ':orgId/org-values', name: 'OrgValues', component: OrgValues },
      { path: ':orgId/why-joining-spotlight', name: 'WhyJoiningSpotlight', component: WhyJoiningSpotlight },
      { path: ':orgId/onboarded', name: 'Onboarded', component: Onboarded },
    ],
  }, {
    path: '/user-onboarding',
    name: 'UserOnboardingView',
    component: UserOnboardingView,
    children: [
      { path: ':inviteId/user-detail', name: 'UserDetail', component: UserDetail },
      { path: ':inviteId/verify-code', name: 'VerifyUserCode', component: VerifyUserCode },
      { path: ':inviteId/agree-rules', name: 'AgreeUserRules', component: AgreeUserRules },
      { path: ':inviteId/causes', name: 'UserCauses', component: UserCauses },
      { path: ':inviteId/channels', name: 'UserChannels', component: UserChannels },
      { path: ':inviteId/values', name: 'UserValues', component: UserValues },
      { path: ':inviteId/why-joining-spotlight', name: 'UserWhyJoiningSpotlight', component: UserWhyJoiningSpotlight },
      { path: ':inviteId/onboarded', name: 'UserOnboarded', component: UserOnboarded },
    ],
  },
  {
    path: '/',
    name: 'DashView',
    beforeEnter: authGuard,
    component: DashView,
    children: [
      // eslint-disable-next-line object-curly-newline
      { path: '/dashboard', alias: '/', name: 'Dashboard', component: Dashboard },
      {
        path: '/activity',
        name: 'ActivityLogs',
        component: ActivityLogs,
      },
      {
        path: '/activity/:id',
        name: 'ActivityLogsForOrganizations',
        component: ActivityLogs,
      },
      {
        path: '/manage',
        name: 'ManageUsersAndOrganizations',
        component: ManageUsersAndOrganizations,
        children: [
          { path: 'users', name: 'ManageUsers', component: ManageUsers },
          { path: 'users/:userId/edit', name: 'ManageUsersEdit', component: ManageUsersEdit },
          { path: 'orgs', name: 'ManageOrganizations', component: ManageOrganizations },
          { path: 'orgs-pending', name: 'ManagePendingOrganizations', component: ManageOrganizations },
          { path: 'orgs/:orgId/edit', name: 'ManageOrganizationsEdit', component: ManageOrganizationsEdit },
          { path: 'orgs/stripe-onboard', name: 'OrgStripeOnboard', component: ConfirmOrgOnboard },
          { path: 'orgs/:orgId/stickers/:id', name: 'ManageOrgSticker', component: OrgSticker },
          { path: 'invites', name: 'Invites', component: Invites },
          { path: 'invites/:inviteId/info', name: 'InviteDetail', component: InviteDetail },
          { path: 'orgs/:orgId/stickers', name: 'ManageOrgStickers', component: ManageOrgStickers },
          { path: 'orgs/:orgId/add-stickers', name: 'AddOrgSticker', component: OrgPageAddSticker },
          { path: 'orgs/:orgId/payment-logs', name: 'Org_Payment_Logs', component: OrgPaymentLogs },
          { path: 'benevity-claim', name: 'BenevityClaim', component: ManageBenevityClaim },
          { path: 'benevity-claim/:claimRequestId', name: 'BenevityClaimDetail', component: ClaimRequestDetailsVue },
          { path: 'supported-causes', name: 'ManageSupportedCauses', component: () => import('../views/manage-users-and-organizations/supported-causes/index.vue') },
          { path: 'consents', name: 'Consents', component: Consents },
        ],
      },

      // ManageContent
      {
        path: '/manage-content',
        name: 'ManageContent',
        component: ManageContent,
        children: [
          { path: 'spots', name: 'ManageContent_Spots', component: ManageContentSpots },
          { path: 'spots/:id', name: 'ManageContent_SpotDetail', component: ManageContentSpotDetail },

          { path: 'events', name: 'ManageContent_Events', component: ManageContentEvents },
          { path: 'events/:id', name: 'ManageContent_EventDetail', component: ManageContentEventDetail },

          // { path: 'payment-logs', name: 'Payment_Logs', component: PaymentLogs },
          { path: 'payment-log/details', name: 'Payment_Log_Details', component: PaymentLogDetails },
        ],
      },
      {
        path: '/manage-content/directory',
        name: 'ManageContent_Directory',
        component: ManageContentDirectory,
        children: [
          { path: 'bullhorns', name: 'ManageContent_Directory_Bullhorns', component: ManageContentDirectoryBullhorns },
          { path: 'bullhorns/:id', name: 'ManageContent_Directory_BullhornDetail', component: ManageContentDirectoryBullhornDetail },

          { path: 'channels', name: 'ManageContent_Directory_Channels', component: ManageContentDirectoryChannels },
          { path: 'channels/:id', name: 'ManageContent_Directory_ChannelDetail', component: ManageContentDirectoryChannelDetail },

          { path: 'values', name: 'ManageContent_Directory_Values', component: ManageContentDirectoryValues },
          { path: 'values/:id', name: 'ManageContent_Directory_ValueDetail', component: ManageContentDirectoryValueDetail },

          { path: 'interests', name: 'ManageContent_Directory_Interests', component: ManageContentDirectoryInterests },
          { path: 'interests/:id', name: 'ManageContent_Directory_InterestDetail', component: ManageContentDirectoryInterestDetail },

          { path: 'dictionary', name: 'ManageContent_Directory_Dictionary', component: ManageContentDirectoryDictionary },
          { path: 'dictionary/:id', name: 'ManageContent_Directory_DictionaryDetail', component: ManageContentDirectoryDictionaryDetail },

          { path: 'segments', name: 'ManageContent_Directory_Segments', component: ManageContentDirectorySegments },
          { path: 'segments/:id', name: 'ManageContent_Directory_SegmentDetail', component: ManageContentDirectorySegmentDetail },
        ],
      },
      {
        path: '/manage-resources',
        name: 'ManageResources',
        component: ManageResources,
        children: [
          { path: 'todos', name: 'Todos', component: Todos },
          { path: 'todos/:id', name: 'Todo', component: Todo },
          { path: 'workflows', name: 'Workflows', component: Workflows },
          { path: 'workflows/:id', name: 'Workflow', component: Workflow },
        ],
      },
      {
        path: '/manage-content/media',
        name: 'ManageContent_Media',
        component: ManageContentMedia,
        children: [
          { path: 'stickers', name: 'ManageContent_Media_Stickers', component: ManageContentMediaStickers },
          { path: 'add-stickers', name: 'ManageContent_Page_AddSticker', component: PageAddSticker },
          { path: 'add-stickers-v2', name: 'AddSticker', component: AddSticker },
          { path: 'stickers/:id', name: 'ManageContent_Media_StickerDetail', component: ManageContentMediaStickerDetail },
          { path: 'stickers-v2/:id', name: 'EditStickers', component: AddSticker },

          { path: 'glows', name: 'ManageContent_Media_Glows', component: ManageContentMediaGlows },
          { path: 'glows/create', name: 'ManageContent_Media_CreateGlow', component: ManageContentMediaCreateGlow },
          { path: 'glows/edit/:id', name: 'ManageContent_Media_EditGlow', component: ManageContentMediaCreateGlow },

          { path: 'static-pages', name: 'ManageContent_Media_StaticPages', component: ManageContentMediaStaticPages },
          { path: 'static-pages/add', name: 'ManageContent_Media_AddStaticPage', component: ManageContentMediaAddStaticPage },
          { path: 'static-pages/:id', name: 'ManageContent_Media_StaticPageDetail', component: ManageContentMediaStaticPageDetail },

          { path: 'questions', name: 'ManageContent_Media_Questions', component: ManageContentMediaQuestions },
          { path: 'questions/:id', name: 'ManageContent_Media_QuestionDetail', component: ManageContentMediaQuestionDetail },

          { path: 'library', name: 'ManageContent_Media_Library', component: ManageContentMediaLibrary },
          { path: 'library/:id', name: 'ManageContent_Media_LibraryItemDetail', component: ManageContentMediaLibraryItemDetail },

          { path: 'add-bullhorn', name: 'ManageContent_Add_Bullhorn', component: ManageContentAddBullhorn },
          { path: 'add-channel', name: 'ManageContent_Add_Channel', component: ManageContentAddChannel },
          { path: 'add-value', name: 'ManageContent_Add_Value', component: ManageContentAddValue },
          { path: 'add-interest', name: 'Interest', component: ManageContentAddInterest },

        ],
      },

      { path: '/marketing', name: 'Marketing', component: Marketing },
      { path: '/civics', name: 'Civics', component: Civics },
      { path: '/settings', name: 'Settings', component: Settings },
      { path: '/fileupload', name: 'FileUpload', component: FileUpload },
      // {
      //   path: '/about',
      //   name: 'About',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/about.vue'),
      // },
      // {
      //   path: '/web',
      //   children: [
      {
        path: '/web/',
        name: 'WebAppHome',
        component: StaticPage,
        props: { slug: 'home-page' },
      },
      // More specific routes must come before generic catch-all routes
      { path: '/web/collection', name: 'CollectionDetail', component: CollectionDetail },
      { path: '/web/dashboard', name: 'WebAppDashboard', component: WebAppDashboard },
      { path: '/web/search', name: 'WebAppSearch', component: Search },
      { path: '/web/supported-causes', name: 'SupportedCauses', component: () => import('../views/web-app/supported-causes/SupportedCauses.vue') },
      { path: '/web/wallet/create', name: 'CreateGivingWallet', component: CreateGivingWallet },
      { path: '/web/wallet/mailing-address', name: 'WalletMailingAddress', component: MailingAddress },
      { path: '/web/wallet/dashboard', name: 'WalletDashboard', component: WalletDashboard },
      { path: '/wallet/add-funds', name: 'AddFunds', component: AddFunds },
      // Generic catch-all route for static pages - must come after specific routes
      {
        path: '/web/page/:slug',
        name: 'WebAppStaticPage',
        component: StaticPage,
        props: true,
      },
      { path: '/web/stickers/purchased', name: 'WebAppPurchasedStickers', component: WebAppPurchasedStickers },
      { path: '/web/ticket-orders', name: 'MyTicketOrders', component: MyTicketOrders, meta: { requiresAuth: true } },
      {
        path: '/web/sticker/:slugorid/analytics',
        name: 'StickerAnalytics',
        component: StickerAnalytics,
        meta: { requiresAuth: true },
      },
      { path: '/web/sticker/:slugorid', name: 'WebAppSticker', component: WebAppSticker },
      { path: '/web/sticker/checkout/:slugorid', name: 'StickerCheckout', component: StickerCheckout },
      { path: '/web/checkout', name: 'TicketCheckout', component: TicketCheckout },
      { path: '/web/ticket/checkout', redirect: '/web/checkout' },
      { path: '/web/ticket/success', name: 'TicketSuccess', component: TicketSuccess },
      { path: '/web/tickets/:stickerId', name: 'TicketsViewer', component: TicketsViewer, meta: { requiresAuth: true } },
      { path: '/web/ticket/:stickerId/detail', name: 'TicketDetailPage', component: TicketDetailPage, meta: { requiresAuth: true } },
      { path: '/web/event/:stickerId/checkin', name: 'HostCheckIn', component: HostCheckIn, meta: { requiresAuth: true } },
      { path: '/web/event/:stickerId/announcements', name: 'HostAnnouncements', component: HostAnnouncements, meta: { requiresAuth: true } },
      { path: '/web/event/:stickerId/questions', name: 'HostQuestions', component: HostQuestions, meta: { requiresAuth: true } },
      { path: '/web/event/:stickerId/insights', name: 'HostTicketInsights', component: HostTicketInsights, meta: { requiresAuth: true } },
      { path: '/web/favorites', name: 'MyFavorites', component: MyFavorites, meta: { requiresAuth: true } },
      { path: '/web/profile/user/:id', name: 'WebAppProfile', component: WebAppProfile },
      { path: '/web/user/:slug', name: 'WebAppUserProfileBySlug', component: WebAppProfile },
      { path: '/web/profile/organization/:id', name: 'WebAppOrgProfile', component: OrganizationProfile },
      { path: '/web/profile/organization', name: 'WebAppOrgProfileNoId', component: OrganizationProfile },
      { path: '/web/org/:slug', name: 'WebAppOrgProfileBySlug', component: OrganizationProfile },
      // Embedded routes - reuse existing components with embedded detection
      { path: '/web/embed/organization/:id', name: 'WebAppOrgProfileEmbed', component: OrganizationProfile },
      { path: '/web/embed/org/:slug', name: 'WebAppOrgProfileEmbedBySlug', component: OrganizationProfile },
      { path: '/web/embed/sticker/:slugorid', name: 'WebAppStickerEmbed', component: WebAppSticker },
      {
        path: '/web/embed/sticker/:slugorid/analytics',
        name: 'StickerAnalyticsEmbed',
        component: StickerAnalytics,
        meta: { requiresAuth: true },
      },
      { path: '/web/embed/sticker/checkout/:slugorid', name: 'WebAppStickerCheckoutEmbed', component: StickerCheckout },
      {
        path: '/web/sandiegogives',
        name: 'SandiegoGives',
        component: OrganizationProfile,
        beforeEnter: (to, from, next) => {
          to.params.slug = 'sandiegogives';
          next();
        },
      },
      //   ],
      // },
      { path: '/auth/web/signin', name: 'WebAppSignIn', component: WebAppSignIn },
      { path: '/auth/web/signup', name: 'WebAppInvite', component: WebAppSignUp },
      { path: '/auth/web/complete-profile', name: 'CompleteProfile', component: WebCompleteProfile },
      // children property is required to avoid Type error
      {
        path: '/auth/web/sticker/:stickerId',
        name: 'WebAppStickerPublic',
        component: WebAppStickerPublic,
        redirect: (to) => ({
          name: 'WebAppSticker',
        }),
        children: [],
      },
    ],
  },
  // Standalone Glow Pages (no auth required, no layout, no sidebar)
  {
    path: '/glow/share/:glowId',
    name: 'ShareGlowPage',
    component: () => import('../views/web-app/glow/ShareGlowPage.vue'),
  },
  {
    path: '/web/glows',
    name: 'WebAppGlowDashboard',
    component: () => import('../views/web-app/glow/GlowDashboard.vue'),
  },
  {
    path: '/web/glows/past',
    name: 'WebAppGlowsPast',
    component: () => import('../views/web-app/glow/PastGlowsList.vue'),
  },
  {
    path: '/web/glows/upcoming',
    name: 'WebAppGlowsUpcoming',
    component: () => import('../views/web-app/glow/UpcomingGlowsList.vue'),
  },
  {
    path: '/web/glow/:glowId',
    name: 'WebAppGlowPage',
    component: () => import('../views/web-app/glow/GlowPage.vue'),
  },
  {
    path: '/web/glow/:id/analytics',
    name: 'WebAppGlowAnalytics',
    component: () => import('../views/web-app/glow/GlowAnalytics.vue'),
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeResolve(authGuard);

router.beforeEach((to, from) => {
  const id = from.params.id ?? from.params.orgId;
  if (to.name === 'AddOrgSticker' && to.params.orgId === 'ORG_ID' && id) {
    router.push(`/manage/orgs/${id}/add-stickers`);
  }
  if (to.name === 'ManageOrgStickers' && to.params.orgId === 'ORG_ID' && id) {
    router.push(`/manage/orgs/${id}/stickers`);
  }
  if (to.name === 'Org_Payment_Logs' && to.params.orgId === 'ORG_ID' && id) {
    router.push(`/manage/orgs/${id}/payment-logs`);
  }
  if (to.params.orgId === 'ORG_ID' && !id) {
    // console.log('missing org id');
  }
});

export default router;
